import { PASSWORD_COMPLEXITY } from "@tickandpass/shared";

// The rule for every password a person sets on their own account (sign-up,
// an invitation, a reset link and a signed-in change): at least 8
// characters with an uppercase letter, a lowercase letter and a number,
// from packages/shared, which the server's rule is tested against. The
// server checks it again; this only answers before the request is sent.
export const PASSWORD_POLICY = PASSWORD_COMPLEXITY;

export const PASSWORD_POLICY_MESSAGE =
  "Password needs at least 8 characters, including an uppercase letter, a lowercase letter and a number.";

/** The message to show for a password that breaks the rule, or null. */
export function passwordProblem(password) {
  return PASSWORD_POLICY.test(password ?? "") ? null : PASSWORD_POLICY_MESSAGE;
}
